import axios from 'axios'
import { BASE_URL_API } from 'constants/base-url-default'

export const handleConfirmEmail = async (token: string) => {
  const response = await axios.get(
    `${BASE_URL_API}/users/confirm?token=${token}`,
    {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    },
  )

  if (response.status !== 200) {
    return false
  }

  return true
}
